import {
  ASSEMBLY_JOURNEY_SECTION_EVENTS_MAP,
  AssemblyJourneys,
  DefaultRotationValues,
} from 'src/constants/assemblyJourneys';
import { IAssemblyConfigLayout, SectionTypes } from 'src/interfaces';

export const getSectionEvents = (
  activeAssemblyJourney: AssemblyJourneys,
  sectionTypes?: SectionTypes[],
): string[] => {
  if (!sectionTypes || !activeAssemblyJourney) return [];

  const events = sectionTypes
    .map(
      (type) =>
        ASSEMBLY_JOURNEY_SECTION_EVENTS_MAP[activeAssemblyJourney]?.[type],
    )
    .filter((event): event is string => !!event);

  return events;
};

export const checkSectionTypes = (sectionTypes?: SectionTypes[]) => {
  const hasCOD = !!sectionTypes?.includes(SectionTypes.COD);
  const hasConfirmation = !!sectionTypes?.includes(SectionTypes.CONFIRMATION);
  const hasDY = !!sectionTypes?.includes(SectionTypes.DY);
  const hasDYR = !!sectionTypes?.includes(SectionTypes.DYR);
  const hasDYS = !!sectionTypes?.includes(SectionTypes.DYS);
  const hasDYP = !!sectionTypes?.includes(SectionTypes.DYP);
  const hasThankYou = !!sectionTypes?.includes(SectionTypes.THANK_YOU);

  const hasJourney = hasCOD || hasDY || hasThankYou;
  const hasSectionRotation = !!sectionTypes?.some(
    (sectionType) => sectionType === SectionTypes.SECTION_ROTATION,
  );
  const hasTakeOver = !!sectionTypes?.some(
    (sectionType) => sectionType === SectionTypes.TAKE_OVER,
  );

  return {
    hasJourney,
    hasSectionRotation,
    hasTakeOver,
    hasCOD,
    hasConfirmation,
    hasDY,
    hasDYR,
    hasDYS,
    hasDYP,
    hasThankYou,
  };
};

export const getRotationIntervalValues = (
  layout?: IAssemblyConfigLayout,
  sectionTypes?: SectionTypes[],
) => {
  const { hasSectionRotation, hasTakeOver } = checkSectionTypes(sectionTypes);

  return {
    defaultLayout: {
      duration:
        layout?.defaultLayout?.duration ?? DefaultRotationValues.DEFAULT,
    },
    ...(hasSectionRotation && {
      sectionRotation: {
        duration:
          layout?.sectionRotation?.duration ??
          DefaultRotationValues.SECTION_TIMER,
      },
    }),
    ...(hasTakeOver && {
      takeover: {
        duration:
          layout?.takeover?.duration ?? DefaultRotationValues.LAYOUT_TIMER,
      },
    }),
  };
};
